import { HttpService } from '../../../services/http.service';
import { Injectable } from '@angular/core';
import { API_URL } from '../../../tokens/api-url.token';

@Injectable({ providedIn: 'root' })
export class UserHttpService extends HttpService {
  createUser(payload: any) {
    return this.http.post(`${this.originatorBaseUrl}users`, payload);
  }

  updateUser(payload: { id: number; data: any }) {
    return this.http.patch(`${this.originatorBaseUrl}users/${payload.id}`, payload.data);
  }

  getUserList() {
    return this.http.get(`${this.originatorBaseUrl}users`);
  }

  deleteUser(id: number) {
    return this.http.delete(`${this.originatorBaseUrl}users/${id}`);
  }
}
